const anyErrors = (errorMessages) =>
  Object.values(errorMessages).some((_) => _);

export default anyErrors;
